<div *ngIf="isLoading" class="loader-spinner-backdrop"></div>
<mat-progress-spinner *ngIf="isLoading" mode="indeterminate" class="loader-spinner"></mat-progress-spinner>
